//Placeholder avatar de perfil
export const avatarPlaceholder =
    'https://resources-one.s3.us-east-2.amazonaws.com/assets/user_placeholder.png'

//Placeholder avatar de perfil local
export const getAvatarPlaceholderLocal = () =>
    require('../../../assets/user_placeholder.png')

//Placeholder general de la App
export const placeholderGeneral =
    'https://resources-one.s3.us-east-2.amazonaws.com/jti/contents/assets/placeholder.png'

//Placeholder para cursos
export const placeholderLearning =
    'https://resources-one.s3.us-east-2.amazonaws.com/sky/contents/assets/faltante.png'

//Placeholder para items de buscador sin media
export const placeholderSearchView =
    'https://resources-one.s3.us-east-2.amazonaws.com/assets/placeholderSearchingView.png'

//Notificaciones
export const notificationIcon = 'https://img.icons8.com/windows/32/reading.png'

//Beneficios: portada de items de Historial
export const pointsEarned =
    'https://resources-one.s3.us-east-2.amazonaws.com/one_sky/assets/folder/pointsEarned.png'

export const placeHolderPost =
    'https://resources-one.s3.us-east-2.amazonaws.com/sky/assets/postavatar.png'
